<div class="inline-block max-h-12 overflow-auto">
  @if (searchItem.coreName) {
    <span class="mr-1">{{ 'catalog.titles.query_to' | transloco }} </span>
  }
  @if (searchItem.coreName) {
    <span class="text-accent">{{ searchItem.coreName }}</span>
  }
  @if (isQueryEmpty()) {
    <span>. </span>
  }
  @if (!isQueryEmpty()) {
    <span class="mr-1">: </span>
  }

  @if (searchItem.coordinates) {
    <mat-icon class="mr-2 text-gray-500">map</mat-icon>
  }

  @for (q of searchItem.parsedQuery; track q) {
    @if (isBracket(q)) {
      <span>{{ q }}</span>
    }
    @if (isLogicalOperator(q)) {
      <span class="text-xs">
        {{ 'castor.logical_operators.' + q | transloco }}
      </span>
    }
    @if (!isBracket(q) && !isLogicalOperator(q)) {
      <span class="mr-1">
        <span [innerHTML]="q"></span>
      </span>
    }
  }
</div>
